export enum Role {
    AUDITOR = 'AUDITOR',
    CARRIER = 'CARRIER',
    WAREHOUSE_EMPLOYEE = 'WAREHOUSE_EMPLOYEE',
}
